import { render, staticRenderFns } from "./BlockQuestionaryInfo.vue?vue&type=template&id=fc9e3a28&"
import script from "./BlockQuestionaryInfo.vue?vue&type=script&lang=ts&"
export * from "./BlockQuestionaryInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports